<template>
  <div class="root home">
    <div class="body_html">
      <h1>查看客户资源</h1>
      <div class="wei_body">
        <div class="tianjia">
          <main>查看资源</main>
          <el-table
            :data="tableData"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            style="width: 58.0rem; text-aligh: center; margin-top: 4.0rem"
          >
            <el-table-column
              prop="phone"
              label="手机号"
              width="130"
            ></el-table-column>
            <el-table-column
              prop="province"
              label="省"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="city"
              label="城市"
              width="100"
            ></el-table-column>
            <el-table-column prop="if_prive" label="分配情况" width="100">
              <template slot-scope="scope">
                <div :class="scope.row.if_prive === 1 ? 'red' : 'blue'">
                  {{ transignificance(scope.row.if_prive, newList) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="addtime"
              label="时间"
              width="150"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      tableData: [],
      url: "https://api.weijub.com",
      newList: { 1: "已分配", 2: "未分配" },
      tooken: "",
      username: {},
    };
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    //   let title = JSON.parse(window.sessionStorage.getItem("title"));
    //   this.title = title;
    //   var a = document.title;
    //   document.title = title[0].website + "-" + a;
    // }
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
    }
    this.abc();
  },
  methods: {
    // tooken验证

    abc() {
      this.axios
        .post(
          "/api/agent/getAgentAccounts",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            agent_id: this.username.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },

    // 提交过后输出的数据\
    transignificance(val, type) {
      for (const key in type) {
        if (key * 1 === val) {
          return type[key];
        }
      }
    },
    dsadas(el) {},
  },
  // 1.用户分配
  // 2.用户分配
};
</script>
<style scoped>
.red {
  color: red;
}
.blue {
  color: blue;
}
</style>


